import React, { useState, useEffect } from 'react';
import { myApi } from '../../../../../config/axiosConfig';
import { Button, Grid2, Paper, Typography } from '@mui/material';
import Swal from 'sweetalert2';

// ICONOS
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';

// COMPONENTES
import MiTabla from '../../../../../components/plantilla/tabla/MiTabla';

const Sukarne = () => {

    // =========================================
    // FUNCION PARA BUSCAR ESPACIOS
    // =========================================

    const [espacios, setEspacios] = useState({ 

        license_capacity: 0,
        active_units: 0,
        spaces_available: 0

    });

    const buscarEspacios = async () => {

        try {

            const response = await myApi.get('/telematica/dogo/espacios');

            setEspacios(response.data);

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // FUNCION PARA BUSCAR UNIDADES ACTIVAS EN DOGO
    // =========================================

    const [datosDogo, setDatosDogo] = useState([]);

    const buscarDogo = async () => {

        try {

            const response = await myApi.get('/telematica/dogo/unidades');

            const data = response.data.map( (datos, index) => ({

                ...datos,
                id: index +1

            }))

            setDatosDogo(data);

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // COLUMNAS PARA DOGO
    // =========================================

    const columnasDogo = [

        { 
            field: 'nombre', 
            headerName: 'Tipo Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.nombre.startsWith('CA_') ? 'Caja' : 'Tractor'
        },
        { 
            field: 'num_economico', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'placa', 
            headerName: 'Placas',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },

    ];

    // =========================================
    // FUNCION PARA ELIMINAR UNIDAD DE DOGO
    // =========================================

    const liberarLicencias = async () => {

        Swal.fire({
            title: 'Liberando Licencias',
            text: 'Por favor, espera...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        try {

            const payload = {

                datosDogo: datosDogo,

            }

            const response = await myApi.post('telematica/dogo/limpiar/licencias', payload);

            if(response.data.success){

                buscarEspacios();
                buscarDogo();

                // Cuando finaliza, mostrar un mensaje de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Proceso completado!',
                    text: 'Las licencias han sido liberadas.',
                    timer: 2000,
                    showConfirmButton: false
                });

            }
    
        } catch (error) {

            // Si ocurre un error, mostrar un mensaje de error
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al liberar las licencias.',
            });

        }

    }

    // =========================================
    // FUNCION PARA BUSCAR UNIDADES ACTIVAS EN DOGO
    // =========================================

    const [bitacora, setBitacora] = useState([]);

    const buscarBitacora = async () => {

        try {

            const response = await myApi.get('/telematica/dogo/bitacora');

            setBitacora(response.data.data);

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // COLUMNAS BITACORA
    // =========================================

    const columnasBitacora = [

        { 
            field: 'nombre', 
            headerName: 'Tipo Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.unitType == 2 ? 'Caja' : 'Tractor'
        },
        { 
            field: 'economico', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'placa', 
            headerName: 'Placas',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'saved_at', 
            headerName: 'Fecha',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },

    ];

    // =========================================
    // USEEFFECT PARA LLAMAR FUNCIONES
    // =========================================

    useEffect(() => {

        buscarEspacios();
        buscarDogo();
        buscarBitacora();

    }, []);

    // =========================================

    return (

        <Grid2 container spacing={2}>

            {/* LICENCIAS */}

            <Grid2 size={4}>

                <Paper elevation={3} sx={{ p: 2 }}>

                    <Typography
                        variant="subtitle2"
                        textAlign={'center'}
                    >
                        Licencias
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        textAlign={'center'}
                        fontWeight={700}
                    >
                        {espacios.license_capacity}
                    </Typography>

                </Paper>

            </Grid2>

            {/* UNIDADES ACTIVAS */}

            <Grid2 size={4}>

                <Paper elevation={3} sx={{ p: 2 }}>

                    <Typography
                        variant="subtitle2"
                        textAlign={'center'}
                    >
                        Licencias Usadas
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        textAlign={'center'}
                        fontWeight={700}
                    >
                        {espacios.active_units}
                    </Typography>

                </Paper>

            </Grid2>

            {/* ESPACIOS DISPONIBLES */}

            <Grid2 size={4}>

                <Paper elevation={3} sx={{ p: 2 }}>

                    <Typography
                        variant="subtitle2"
                        textAlign={'center'}
                    >
                        Licencias Disponibles
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        textAlign={'center'}
                        fontWeight={700}
                    >
                        {espacios.spaces_available}
                    </Typography>

                </Paper>

            </Grid2>

            <Grid2 size={12} sx={{ display: 'flex', justifyContent: 'center' }}>

                <Button
                    variant='contained'
                    endIcon={<CleaningServicesIcon />}
                    onClick={liberarLicencias}
                >
                    Liberar Licencias
                </Button>

            </Grid2>

            {/* TABLA PARA REGISTROS DE DOGO */}

            <Grid2 size={6}>

                <Typography
                    variant="h6"
                    textAlign={'center'}
                    fontWeight={700}
                >
                    Registros Dogo
                </Typography>

                <MiTabla
                    columns={columnasDogo}
                    data={datosDogo}
                />

            </Grid2>

            {/* TABLA PARA REGISTROS DE BITACORA */}

            <Grid2 size={6}>

                <Typography
                    variant="h6"
                    textAlign={'center'}
                    fontWeight={700}
                >
                    Registros Bitacora
                </Typography>

                <MiTabla
                    columns={columnasBitacora}
                    data={bitacora}
                />

            </Grid2>

        </Grid2>

    )

}

export default Sukarne